import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  oobCode: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  
  isVerifying: boolean = true;
  isValidCode: boolean = false;
  isSubmitting: boolean = false;
  
  errorMessage: string = '';
  successMessage: string = '';
  hidePassword = true;
  hideConfirmPassword = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.oobCode = params['oobCode'];
      const mode = params['mode'];
      const continueUrl = params['continueUrl'];
      
      // If we are on production but the continueUrl is for localhost, redirect to localhost
      if (continueUrl && continueUrl.startsWith('http://localhost')) {
        const currentUrl = window.location.href;
        if (!currentUrl.startsWith('http://localhost')) {
          // Reconstruct the localhost URL with the oobCode and mode
          const redirectUrl = new URL(continueUrl);
          redirectUrl.searchParams.set('mode', mode);
          redirectUrl.searchParams.set('oobCode', this.oobCode);
          window.location.href = redirectUrl.toString();
          return;
        }
      }

      if (mode !== 'resetPassword' || !this.oobCode) {
        this.errorMessage = 'Invalid password reset link.';
        this.isVerifying = false;
        return;
      }
      
      this.verifyCode();
    });
  }

  async verifyCode() {
    try {
      await this.authService.verifyResetCode(this.oobCode);
      this.isValidCode = true;
    } catch (error: any) {
      this.errorMessage = 'This password reset link is invalid or has already been used.';
    } finally {
      this.isVerifying = false;
    }
  }

  async onSubmit() {
    if (!this.newPassword || this.newPassword !== this.confirmPassword) {
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';

    try {
      await this.authService.confirmPasswordReset(this.oobCode, this.newPassword);
      this.successMessage = 'Your password has been reset successfully. You can now log in with your new password.';
    } catch (error: any) {
      this.errorMessage = 'Failed to reset password. Please try again.';
      console.error(error);
    } finally {
      this.isSubmitting = false;
    }
  }

  goToLogin() {
    this.router.navigate(['/auth/login']);
  }
}
